
<template>
  <div class="container-fluid">
    <main id="page-wrap">
    </main>
    <div class="overlay show" v-if="!renderComponent">
      <div id="loading-spinner">
        <div class="spin-icon"></div>
      </div>
    </div>
    <div :id="$route.query.lang" v-else>
      <arStyles v-if="$route.query.lang == 'ar' || $route.query.language == 'ar'"></arStyles>
     <headerTop @forceRerender="forceRerender($event)" @showLoader="showLoader($event)"></headerTop>
   <!-- <headerMantacice></headerMantacice>-->

    <!-- <div style="background-color:black;height:89px"></div> -->
      <studentLayout v-if="$route.meta.layout =='student'"/>
      <parentLayout v-if="$route.meta.layout =='parent'" />
      <teacherLayout v-if="$route.meta.layout =='teacher'"/>
      <schoolLayout v-if="$route.meta.layout =='school'" />
      <adminLayout   v-if="$route.meta.layout =='admin'" />
      <gameLayout v-if="$route.meta.layout =='game'" />
      <guestLayout v-if="$route.meta.layout =='guest'" />
       <!-- <Maintenance /> -->

     <!-- <competitionModal/>-->
    </div>
  </div>
</template>
<script>
import { eventBus } from "@/main";
import router from "@/routes";

require("./assets/css/app.css");
const studentLayout = () =>
  import(/* webpackChunkName: "studentLayout" */ "./components/layouts/student.vue");
const teacherLayout = () =>
  import(/* webpackChunkName: "teacherLayout" */ "./components/layouts/teacher.vue");
const parentLayout = () =>
  import(/* webpackChunkName: "parentLayout" */ "./components/layouts/parent.vue");
const schoolLayout = () =>
  import(/* webpackChunkName: "schoolLayout" */ "./components/layouts/school.vue");
  const gameLayout = () =>
  import(/* webpackChunkName: "schoolLayout" */ "./components/layouts/game.vue");
   const guestLayout = () =>
  import(/* webpackChunkName: "schoolLayout" */ "./components/layouts/guest.vue");
const headerTop = () =>
  import(/* webpackChunkName: "headerTop" */ "./components/shared/header.vue");
  const headerMantacice = () =>
  import(/* webpackChunkName: "headerTop" */ "./components/shared/headerMantacice.vue");
const arStyles = () =>
  import(/* webpackChunkName: "headerTop" */ "./components/localStyle/ar/main.vue");
  const adminLayout = () =>
  import(/* webpackChunkName: "schoolLayout" */ "./components/layouts/admin.vue");
  const Maintenance =() => import ("./components/Maintenance.vue")


export default {
  data() {
    return {
      renderComponent: true,
      renderStyle: false,
      openModal:false,
      
    };
  },
  beforeUpdate() {},
  created() {
      if(window.location.href == 'https://hellocode.me/' || window.location.href == 'https://www.hellocode.me/'){
      let lang = 'ar'
      router.push({ query: { lang } });
    }
    const cliantInfo = this.$store.getters.getCliantInfo
    if(!cliantInfo){
      this.$store.dispatch('getCliantInfo')
    }
  },
  mounted(){
   window.addEventListener('storage', function(event){
    if (event.key == 'logout-event') { 
     localStorage.removeItem('token');
     window.location.reload();
    }
    if (event.key == 'login-event') {
      window.location.reload();
    }
    });
  },
    watch: {
    openModal(val) {
         if(!this.$store.getters.isAuth && this.$route.name!="Login" && this.$route.name!="Register"){
      eventBus.$emit('showLoginModal');
       }
    },
  
  },
  components: {
    studentLayout,
    teacherLayout,
    parentLayout,
    schoolLayout,
    gameLayout,
    guestLayout,
    headerTop,
    arStyles,
    adminLayout,
    headerMantacice,
    Maintenance

    //competitionModal,
  },
  methods: {
    forceRerender() {
      // Remove my-component from the DOM
      let vm = this;
      vm.renderComponent = false;
      setTimeout(() => {
        vm.renderComponent = true;
      }, 1000);
    },
  },
};
</script>
<style scoped>
#loading-spinner {
  display: inline;
  position: relative;
  z-index: 999999;
}

#loading-spinner .spin-icon {
  margin: auto;
  width: 80px;
  height: 80px;
  margin-top: 24%;
  border: solid 3px transparent;
  border-top-color: #001f5b;
  border-left-color: #49c1df;
  border-radius: 80px;

  -webkit-animation: loading-spinner 500ms linear infinite;
  -moz-animation: loading-spinner 500ms linear infinite;
  -ms-animation: loading-spinner 500ms linear infinite;
  -o-animation: loading-spinner 500ms linear infinite;
  animation: loading-spinner 500ms linear infinite;
}

@-webkit-keyframes loading-spinner {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-moz-keyframes loading-spinner {
  0% {
    -moz-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-o-keyframes loading-spinner {
  0% {
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-ms-keyframes loading-spinner {
  0% {
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loading-spinner {
  0% {
    transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue